import React from 'react';
import { Button } from './ui/Button';
import { CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const credibilityPoints = ['Established in 1995', 'Offices in Wixom & Kalamazoo, Michigan', 'Factory-trained service engineers', 'Used Wire & Sinker EDM expertise', 'Fast response for Michigan manufacturers'];
  return <section className="relative bg-gradient-to-br from-navy via-navy to-blue text-white py-16 md:py-24" data-id="element-323">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-324">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-325">
          {/* Left Column: Text Content */}
          <div data-id="element-326">
            {/* Trust Badge */}
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-id="element-327">
              <span className="text-orange font-bold text-sm" data-id="element-328">★</span>
              <span className="text-sm font-semibold" data-id="element-329">
                Established 1995 • 30+ Years of Excellence
              </span>
            </div>

            {/* H1 - Only one on page */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-330">
              Peak Machine Sales
            </h1>

            {/* Subheading */}
            <p className="text-xl md:text-2xl text-blue-100 mb-6 font-medium" data-id="element-331">
              Michigan's Precision CNC Machine Dealer (Sales & Service Since
              1995)
            </p>

            {/* Primary CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-332">
              <Button variant="primary" size="lg" href="59m7/used-machines.html" data-id="element-333">
                Browse Used EDM / CNC Inventory
              </Button>
              <Button variant="secondary" size="lg" href="https://www.peakedm.com/SellingUsedEDM?" external className="bg-white/10 border-white text-white hover:bg-white hover:text-navy" data-id="element-334">
                Sell Your Used EDM
              </Button>
            </div>

            {/* Credibility Bullets - Compact */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-6 border-t border-white/20" data-id="element-335">
              {credibilityPoints.map((point, index) => <div key={index} className="flex items-start space-x-2" data-id="element-336">
                  <CheckCircleIcon className="w-4 h-4 text-orange flex-shrink-0 mt-0.5" data-id="element-337" />
                  <span className="text-blue-50 text-sm" data-id="element-338">{point}</span>
                </div>)}
            </div>
          </div>

          {/* Right Column: Image Placeholder */}
          <div className="hidden lg:block" data-id="element-339">
            <div className="w-full h-[400px] bg-white/10 backdrop-blur-sm rounded-lg border-2 border-white/20 flex items-center justify-center" data-id="element-340">
              <div className="text-center" data-id="element-341">
                <div className="w-20 h-20 bg-white/20 rounded-full mx-auto mb-4 flex items-center justify-center" data-id="element-342">
                  <span className="text-white text-3xl" data-id="element-343">🏭</span>
                </div>
                <span className="text-white/60 text-sm font-medium" data-id="element-344">
                  CNC Machine Image Placeholder
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}